export default __webpack_public_path__ + "static/media/5.492c04ab.jpg";